"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BettingValidator = exports.BettingRecommender = exports.BetHintKind = exports.BetHint = void 0;
const class_transformer_1 = require("class-transformer");
const __1 = require("../");
const Language_1 = require("../lang/Language");
var BetHintKind;
(function (BetHintKind) {
    BetHintKind["fractionofpot"] = "fractionofpot";
    BetHintKind["multiplesofbigblind"] = "multiplesofbigblind";
    BetHintKind["multiplesoflastbet"] = "multiplesoflastbet";
})(BetHintKind || (BetHintKind = {}));
exports.BetHintKind = BetHintKind;
class BetHint {
    constructor(amount, kind, label) {
        this.amount = amount;
        this.kind = kind;
        this.label = label;
    }
}
__decorate([
    class_transformer_1.Transform(({ value }) => BetHintKind[value.toLowerCase()]),
    __metadata("design:type", String)
], BetHint.prototype, "kind", void 0);
exports.BetHint = BetHint;
class BettingRecommender {
    static getBetHints(board) {
        if (board.isPreDeal() || board.isShowdown()) {
            return [];
        }
        if (board.isDeal()) {
            return BettingRecommender.getHintsBeforeAction(board);
        }
        else {
            return BettingRecommender.getBetsAfterAction(board);
        }
    }
    static getHintsBeforeAction(board) {
        if (board.hasBetsNoChecks()) {
            return BettingRecommender.getMultiplesOfLastBet(board);
        }
        else {
            return BettingRecommender.getMultiplesOfBigBlind(board);
        }
    }
    static getBetsAfterAction(board) {
        if (board.hasBetsNoChecks()) {
            return BettingRecommender.getMultiplesOfLastBet(board);
        }
        else {
            return BettingRecommender.getFractionsOfPot(board);
        }
    }
    static getMultiplesOfBigBlind(board) {
        return BettingRecommender.multipliersOfBlind.map((multiplier) => ({
            kind: BetHintKind.multiplesofbigblind,
            amount: Math.floor(multiplier[0] * board.blinds.big),
            label: multiplier[1],
        }));
    }
    static getMultiplesOfLastBet(board) {
        return BettingRecommender.multipliersOfBet.map((multiplier) => ({
            kind: BetHintKind.multiplesoflastbet,
            amount: Math.floor(multiplier[0] * board.lastBet()),
            label: multiplier[1],
        }));
    }
    static getFractionsOfPot(board) {
        return BettingRecommender.fractionsOfPot
            .map((fractional) => {
            return {
                kind: BetHintKind.fractionofpot,
                amount: Math.floor(fractional[0] * board.getTotalPotsValue()),
                label: fractional[1],
            };
        })
            .filter((betHint) => betHint.amount >= board.blinds.big);
    }
}
exports.BettingRecommender = BettingRecommender;
BettingRecommender.multipliersOfBlind = [
    [2, Language_1.Language.strings.betHints.multipleOfBlind.twoTimes],
    [3, Language_1.Language.strings.betHints.multipleOfBlind.threeTimes],
    [4, Language_1.Language.strings.betHints.multipleOfBlind.fourTimes],
];
BettingRecommender.multipliersOfBet = [
    [2, Language_1.Language.strings.betHints.multipleOfBet.twoTimes],
    [3, Language_1.Language.strings.betHints.multipleOfBet.threeTimes],
    [4, Language_1.Language.strings.betHints.multipleOfBet.fourTimes],
];
BettingRecommender.fractionsOfPot = [
    [1 / 3, Language_1.Language.strings.betHints.fractionOfPot.oneThird],
    [0.5, Language_1.Language.strings.betHints.fractionOfPot.oneHalf],
    [0.75, Language_1.Language.strings.betHints.fractionOfPot.threeQuarters],
    [1, Language_1.Language.strings.betHints.fractionOfPot.fullPot],
];
class BettingValidator {
    static isValidBetForPlayer(bigBlind, biggestBet, playerBet, playerChips, betAmount) {
        return [
            BettingValidator.betAmountIsGreaterThanPlayersBet,
            BettingValidator.betAmountIsLessThanPlayersTotalChips,
            BettingValidator.betAmountIsAsBigAsBigBlindBet,
            BettingValidator.betAmountIsAsBigAsBiggestBet,
        ]
            .reduce((results, validFx) => {
            results.push(validFx(bigBlind, biggestBet, playerBet, playerChips, betAmount));
            return results;
        }, [])
            .every((result) => result === true);
    }
    static betAmountIsGreaterThanPlayersBet(bigBlind, biggestBet, playerBet, playerChips, betAmount) {
        if (betAmount > playerBet) {
            return true;
        }
        __1.logger.trace('bet must be greater than players current bet');
        return false;
    }
    static betAmountIsLessThanPlayersTotalChips(bigBlind, biggestBet, playerBet, playerChips, betAmount) {
        if (betAmount <= playerBet + playerChips) {
            return true;
        }
        __1.logger.trace('bet must be less than players chips and current bet (total chip stack)');
        return false;
    }
    static betAmountIsAsBigAsBigBlindBet(bigBlind, biggestBet, playerBet, playerChips, betAmount) {
        if (betAmount > 0) {
            return true;
        }
        __1.logger.trace('bet must be as big as boards big blind');
        return false;
    }
    static betAmountIsAsBigAsBiggestBet(bigBlind, biggestBet, playerBet, playerChips, betAmount) {
        if (biggestBet <= 0 || (biggestBet > 0 && betAmount >= biggestBet)) {
            return true;
        }
        __1.logger.trace('bet must be as big as boards biggest bet');
        return false;
    }
}
exports.BettingValidator = BettingValidator;
//# sourceMappingURL=BettingRecommender.js.map